import {getAxiosInstance} from "../../http-common";
import { LoginAzureRequest } from "../../models/auth/LoginAzureRequest";
import { LoginRequest } from "../../models/auth/LoginRequest";
import { LogoutRequest } from "../../models/auth/LogoutRequest";

const RESOURCE_NAME_LOGIN = "login";
const RESOURCE_NAME_LOGOUT = "logout";

const login = (model: any) => {
  const http = getAxiosInstance();
  return http.post<LoginRequest>(RESOURCE_NAME_LOGIN, model);
};
const loginAzure = (model: any) => {
  const http = getAxiosInstance();
  return http.post<LoginAzureRequest>(`${RESOURCE_NAME_LOGIN}/Azure`, model);
};
const logout = (model: any) => {
  const http = getAxiosInstance();
  return http.post<LogoutRequest>(RESOURCE_NAME_LOGOUT, model);
};

const AuthService = {
  login,
  loginAzure,
  logout,
};
export default AuthService;

// get - dohvat
// post - slanje
// put - slanje, update
// delete - brisanje
